/* LEDaura — Konfigurator Helfer */
(function() {
  var WUNSCH_VARIANTS = ['51152701194518', '51152701227286', '51152701260054'];

  // Konfigurator: nicht verfügbare Optionen ausblenden
  function hideKonfigOptions() {
    var rgb = document.querySelector('[data-option="led"][data-value="3"]');
    if (rgb && rgb.style.display !== 'none') rgb.style.display = 'none';
    var netz = document.getElementById('lrNetzteil');
    if (netz && netz.style.display !== 'none') netz.style.display = 'none';
  }

  // Warenkorb: Mengen-Stepper für Wunsch-LED verstecken
  function hideWunschQtyControls() {
    document.querySelectorAll('.cart-items__quantity-controls').forEach(function(ctrl) {
      // Suche das umgebende Cart-Item (tr, li, oder generisches Container-Element)
      var row = ctrl.closest('tr, li, [class*="cart-item"], [class*="line-item"]') || ctrl.parentElement;
      if (!row) return;
      var keyEl = row.querySelector('[data-key]');
      if (!keyEl) return;
      var key = keyEl.getAttribute('data-key') || '';
      if (WUNSCH_VARIANTS.some(function(vid) { return key.indexOf(vid) === 0; })) {
        ctrl.style.display = 'none';
      }
    });
  }

  var hideTimer = null;
  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function() {
      hideKonfigOptions();
      hideWunschQtyControls();
    }, 50);
  }

  scheduleHide();

  new MutationObserver(function(mutations) {
    var relevant = mutations.some(function(m) {
      return m.addedNodes.length > 0 || m.removedNodes.length > 0 ||
             (m.type === 'attributes' && m.target.id !== 'lrNetzteil' &&
              !(m.target.dataset && m.target.dataset.value === '3'));
    });
    if (relevant) scheduleHide();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
